import { PageLayoutContentMainAreaAriaRole } from '@ms/yammer-web-core-ui/dist/components/PageLayout';
import { createContext } from 'react';
export const defaultOptions = {
    mainAreaAriaRole: PageLayoutContentMainAreaAriaRole.Main,
    enableCollapsiblePanelNav: false,
    enableCommunityDiscoveryV2: false,
    fullScreenModalDialogMarginTop: undefined,
    messagePanelMarginTop: undefined,
    disableVideoPlayer: false,
};
export default createContext(defaultOptions);
//# sourceMappingURL=context.js.map